import { render, staticRenderFns } from "./HeaderAreaNew.vue?vue&type=template&id=db1eca14"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderInfoBar: require('/vercel/path0/components/HeaderInfoBar.vue').default})
